/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Unit, `t` for tonne, `kg` for kilogram, `g` for gram
 */
export var MassUnit;
(function (MassUnit) {
    MassUnit["G"] = "g";
    MassUnit["KG"] = "kg";
    MassUnit["T"] = "t";
})(MassUnit || (MassUnit = {}));
//# sourceMappingURL=MassUnit.js.map